module.exports = __webpack_public_path__ + "img/TV.488027e4.svg";